import * as React from "react";
import PropTypes from "prop-types";
import SelectItem from "../../internal/SelectItem";
import { valuePropType } from "../../Select/SelectDialog";
import FormError from "../../FormError";
import Theme from "../../Theme";

export default class SelectField extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: valuePropType,
    onChange: PropTypes.func,
    error: PropTypes.string,
    placeholder: PropTypes.bool,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label: PropTypes.string.isRequired,
        value: valuePropType.isRequired,
        icon: PropTypes.node,
      })
    ),
    infoIcon: PropTypes.bool,
    infoText: PropTypes.string,
  };

  static defaultProps = {
    options: [],
  };

  state = { value: this.props.value };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.value !== this.state.value) {
      this.setState({ value: nextProps.value });
    }
  }

  handleChange = (newValue) => {
    this.setState({ value: newValue });
    if (this.props.onChange) {
      this.props.onChange(newValue);
    }
  };

  render() {
    const {
      name,
      label,
      options,
      error,
      placeholder,
      infoIcon,
      infoText,
    } = this.props;
    const { value } = this.state;

    return (
      <div
        data-component-name="SelectField"
        data-prop-name={name}
        data-prop-value={value == null ? "" : value.toString()}
      >
        <FormError error={error}>
          <div style={{ padding: Theme.Padding.CONTENT }}>
            <SelectItem
              label={label}
              options={options}
              value={value}
              onChange={this.handleChange}
              placeholder={placeholder}
              infoIcon={infoIcon}
              infoText={infoText}
            />
          </div>
        </FormError>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ../nx-components/src/Form/fields/SelectField.jsx